import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';
import { navBarHeight } from 'styles/variables';

const NavBar = styled.nav`
    display: flex;
    border-bottom: 1px solid ${tokens.nav.border};
    min-height: ${navBarHeight}px;
    align-items: stretch;
`;

export const NavItem = styled.div`
    display: flex;
    padding: 1.5rem 2.5rem;
    align-items: center;
    border-left: 0;
    justify-content: flex-end;
    @media ${MediaQueries.largeAndUp} {
        border-left: 1px solid ${tokens.nav.border};
        justify-content: space-between;
    }
    &:first-child {
        border-left: 0;
    }
`;

export { NavBar };
